<template>
    <v-content class="pa-12">
        <v-layout style="background-color: #FAF5F2;">
            <v-flex>
                <!-- Nevigater -->
                <v-layout mb-12>
                    <v-flex shrink d-flex justify-start align-center class="nevigater-link" @click="$router.push('/post-approve')">
                        <span>Post Approve</span>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center>
                        <v-icon color="#3E7662">arrow_right</v-icon>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center class="nevigater-link"  @click="viewData">
                        <span>ดูข้อมูล</span>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center>
                        <v-icon color="#3E7662">arrow_right</v-icon>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
                        <span>รายงานเหตุการณ์การไม่พึ่งประสงค์ (นอกเหนือจากยา)</span>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex>
                        <v-layout mt-3 style="background-color: #3E7662;">
                            <v-flex my-8 ml-8 style="text-align: left;font-size: 28px;color: white" @click="setData">
                                <div style="font-weight: bold">แบบรายงานเหตุการณ์ไม่พึงประสงค์ (SAE) </div>
                                <div style="font-size: 18px;">Adverse Event Report</div>
                            </v-flex>
                            <v-flex ml-8 pt-8 pr-8 style="text-align: right;font-weight: bold;font-size: 13px;color: white">
                                <span>RF 04_2_2563</span>
                            </v-flex>
                        </v-layout>

                        <!-- blog 1 -->
                        <v-card class="py-12" style="padding-right: 80px;padding-left: 80px">
                            <v-layout>
                                <v-flex>

                                    <!-- row 1 -->
                                    <v-layout pb-3>
                                        <v-flex style="text-align: left;font-weight: bold;">
                                            <span>1. รหัสโครงการ</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <textfield-form
                                                    :model="form.researchCode"
                                                    @update-data="updateData('researchCode', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 2 -->
                                    <v-layout pb-3>
                                        <v-flex style="text-align: left;font-weight: bold;">
                                            <span>2. ชื่อโครงการวิจัย</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <textarea-form
                                                    :model="form.researchName"
                                                    @update-data="updateData('researchName', $event)"
                                            ></textarea-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 3 -->
                                    <v-layout pb-3>
                                        <v-flex style="text-align: left;font-weight: bold;">
                                            <span>3. ชื่อผู้วิจัยหลัก</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout px-4>
                                        <v-flex style="color: #3E7662">
                                            <textfield-form
                                                    label="ชื่อ"
                                                    :model="form.firstName"
                                                    @update-data="updateData('firstName', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                        <v-flex ml-3 style="color: #3E7662">
                                            <textfield-form
                                                    label="นามสกุล"
                                                    :model="form.lastName"
                                                    @update-data="updateData('lastName', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 4 -->
                                    <v-layout pb-3>
                                        <v-flex style="text-align: left;font-weight: bold;">
                                            <span>4. สังกัด / เบอร์โทรศัพท์ติดต่อ</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout pb-3>
                                        <v-flex>
                                            <textfield-form
                                                    :model="form.affiliationAndPhoneNumber"
                                                    @update-data="updateData('affiliationAndPhoneNumber', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 5 -->
                                    <v-layout pb-3 justify-space-between>
                                        <v-flex mr-6 shrink d-flex align-center style="text-align: left;font-weight: bold;">
                                            <span>5. อาสาสมัคร</span>
                                        </v-flex>
                                        <v-flex shrink style="text-align: left;font-weight: bold;" mt-1>
                                            <v-checkbox color="#3E7662" v-model="form.volunteer_checkbox" @change="volunteerChangeCheckbox()" hide-details />
                                        </v-flex>
                                        <v-flex mr-6 shrink d-flex align-center style="text-align: left;font-weight: bold;color: #CC3D45">
                                            <span>ในสถาบัน *ระบุหน่วย</span>
                                        </v-flex>
                                        <v-flex d-flex align-center>
                                            <textfield-form
                                                    :disabled="!form.volunteer_checkbox"
                                                    hide-detail
                                                    :model="form.volunteerDepartment"
                                                    @update-data="updateData('volunteerDepartment', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 6 -->
                                    <v-layout pt-6 justify-space-between>
                                        <v-flex mr-10 shrink d-flex align-center style="text-align: left;font-weight: bold;">
                                            <span>6. ชื่อย่อ/รหัสอาสาสมัคร Patient Initial</span>
                                        </v-flex>
                                        <v-flex d-flex align-center>
                                            <textfield-form
                                                    hide-detail
                                                    :model="form.volunteerCode"
                                                    @update-data="updateData('volunteerCode', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 7 -->
                                    <v-layout pt-10>
                                        <v-flex xs2 mr-10 d-flex align-center style="text-align: left;font-weight: bold;">
                                            <span>7. วันเกิด</span>
                                        </v-flex>
                                        <v-flex xs2 d-flex align-center>
                                            <DateInputForm
                                                    hide-detail
                                                    :model="birthDate"
                                                    @update-data="updateDate('birthDate', $event)"
                                            ></DateInputForm>
                                        </v-flex>
                                        <v-flex justify-end xs2 d-flex align-center>
                                            <span style="text-align: left;font-weight: bold;">8. อายุ</span>
                                        </v-flex>
                                        <v-flex xs2 mx-4 d-flex align-center>
                                            <textfield-form
                                                    hide-detail
                                                    :model="form.age"
                                                    @update-data="updateData('age', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                        <v-flex xs2 d-flex align-center>
                                            <span style="text-align: left;font-weight: bold;">ปี</span>
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 8 -->
                                    <v-layout mt-4>
                                        <v-flex xs2 mr-10 d-flex align-center style="text-align: left;font-weight: bold;">
                                            <span>9. เพศ</span>
                                        </v-flex>
                                        <v-flex pt-6 d-flex align-center style="text-align: left;">
                                            <v-radio-group v-model="form.gender" row>
                                                <v-radio color="#3E7662" style="padding-right: 40px" label="ชาย" value="0"></v-radio>
                                                <v-radio color="#3E7662" label="หญิง" value="1"></v-radio>
                                            </v-radio-group>
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 9 -->
                                    <v-layout mt-4>
                                        <v-flex xs2 mr-10 d-flex align-center style="text-align: left;font-weight: bold;">
                                            <span>10. วันที่เกิดอาการ</span>
                                        </v-flex>
                                        <v-flex xs2 d-flex align-center>
                                            <DateInputForm
                                                    hide-detail
                                                    :model="date"
                                                    @update-data="updateDate('date', $event)"
                                            ></DateInputForm>
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 9 -->
                                    <v-layout mb-3 mt-10>
                                        <v-flex style="text-align: left;font-weight: bold;">
                                            <span>11.รายละเอียดเหตุการณ์ไม่พึงประสงค์ (รวมทั้งการตรวจทางห้องปฏิบัติการ)</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <textarea-form
                                                    hide-detail
                                                    :model="form.detail"
                                                    @update-data="updateData('detail', $event)"
                                                    :rows="8"
                                            />
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 10 -->
                                    <v-layout mb-3 mt-10>
                                        <v-flex style="text-align: left;font-weight: bold;">
                                            <span>12. ชนิดของการรายงาน</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout ml-4>
                                        <v-flex>
                                            <v-flex>
                                                <v-radio-group v-model="form.type" row>
                                                    <v-radio color="#3E7662" style="padding-right: 100px" label="ครั้งแรก Initial report" value="0"></v-radio>
                                                    <v-radio color="#3E7662" label="เพื่อติดตาม Follow-up report" value="1"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 11 -->
                                    <v-layout mb-3 mt-4>
                                        <v-flex style="text-align: left;font-weight: bold;">
                                            <span>13. ความสัมพันธ์กับการวิจัย (Relation to the study)</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout ml-4>
                                        <v-flex>
                                            <v-radio-group v-model="form.relation">
                                                <v-radio color="#3E7662" label="1. ไม่เกี่ยวข้อง (Not related)" value="1"></v-radio>
                                                <v-radio color="#3E7662" label="2. อาจเกี่ยวข้อง (Possibly related)" value="2"></v-radio>
                                                <v-radio color="#3E7662" label="3. น่าจะเกี่ยวข้อง (Probably related)" value="3"></v-radio>
                                                <v-radio color="#3E7662" label="4. เกี่ยวข้องแน่นอน (Definitely related)" value="4"></v-radio>
                                                <v-radio color="#3E7662" label="5. ไม่รู้ (Unknown)" value="5"></v-radio>
                                            </v-radio-group>
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 12 -->
                                    <v-layout mb-3 mt-4>
                                        <v-flex style="text-align: left;font-weight: bold;">
                                            <span>14. ลงนามผู้วิจัย</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout ml-4>
                                        <v-flex>
                                            <TextfieldForm
                                                    style="color: #3E7662"
                                                    label="ชื่อ"
                                                    :model="form.signatureFirstName"
                                                    @update-data="updateData('signatureFirstName', $event)"
                                            />
                                        </v-flex>
                                        <v-flex ml-12>
                                            <TextfieldForm
                                                    style="color: #3E7662"
                                                    label="นามสกุล"
                                                    :model="form.signatureLastName"
                                                    @update-data="updateData('signatureLastName', $event)"
                                            />
                                        </v-flex>
                                    </v-layout>

                                    <!-- row 13 -->
                                    <v-layout mt-4 mb-12>
                                        <v-flex shrink mr-10 d-flex align-center style="text-align: left;font-weight: bold;">
                                            <span>15. วันที่รายงาน</span>
                                        </v-flex>
                                        <v-flex xs2 d-flex align-center>
                                            <DateInputForm
                                                    hide-detail
                                                    :model="reportDate"
                                                    @update-data="updateDate('reportDate', $event)"
                                            ></DateInputForm>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout pt-10>
                                        <v-flex xs11 style="text-align: left;font-size: 14px; color: #CC3D45">
                                        <span>
                                            *ถ้าเป็นเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรง (ก 1-5) ผู้วิจัยควรส่งรายงานแก่คณะอนุกรรมการพิจารณาโครงการวิจัย พบ. ภายใน 7 วัน หลังทราบเหตุการณ์
                                        </span>
                                        </v-flex>
                                    </v-layout>

                                </v-flex>
                            </v-layout>
                        </v-card>

                        <!-- blog 2 -->
                        <v-layout mt-12 py-12 style="background-color: white;padding-right: 80px;padding-left: 80px">
                            <v-flex>
                                <!-- row 1 -->
                                <v-layout mt-8 mb-3>
                                    <v-flex style="text-align: left;font-weight: bold;">
                                        <span>ก. ตรวจสอบความร้ายแรง (severity)</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout ml-4>
                                    <v-flex>
                                        <v-radio-group v-model="form.severity">
                                            <v-radio color="#3E7662" label="1. ตาย (Death)" value="1"></v-radio>
                                            <v-radio color="#3E7662" label="2. รุนแรงและอาจทำให้เสียชีวิต (Life threatening)" value="2"></v-radio>
                                            <v-radio color="#3E7662" label="3. ต้องรักษาในโรงพยาบาล (Hospitalization / prolonged hospitalization)" value="3"></v-radio>
                                            <v-radio color="#3E7662" label="4. พิการหรือทุพลภาพ (Persistent or significant disability / incapacity)" value="4"></v-radio>
                                            <v-radio color="#3E7662" label="5. ทารกพิการแต่กำเนิด (Congenital anomaly / birth defect)" value="5"></v-radio>
                                            <v-radio color="#3E7662" label="6. ไม่ร้ายแรง" value="6"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>

                                <!-- row 2 -->
                                <v-layout mt-8 mb-3>
                                    <v-flex style="text-align: left;font-weight: bold;">
                                        <span>ข. อาการหายไปหลังหยุดยาหรือไม่</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout ml-4>
                                    <v-flex>
                                        <v-radio-group v-model="form.hasCure" row>
                                            <v-radio color="#3E7662" label="หายไป" value="1"></v-radio>
                                            <v-radio color="#3E7662" label="ไม่หาย" value="2"></v-radio>
                                            <v-radio color="#3E7662" label="ตอบไม่ได้" value="3"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>

                                <!-- row 3 -->
                                <v-layout mt-8 mb-3>
                                    <v-flex style="text-align: left;font-weight: bold;">
                                        <span>ค. อาการเกิดขึ้นใหม่ เมื่อกลับให้ยาอีกหรือไม่</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout ml-4>
                                    <v-flex>
                                        <v-radio-group v-model="form.hasRecurrentAfterStop" row>
                                            <v-radio color="#3E7662" label="เกิดซ้ำ" value="1"></v-radio>
                                            <v-radio color="#3E7662" label="ไม่เกิดอีก" value="2"></v-radio>
                                            <v-radio color="#3E7662" label="ตอบไม่ได้" value="3"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>

                                <!-- row 4 -->
                                <v-layout mt-8 mb-3>
                                    <v-flex style="text-align: left;font-weight: bold;">
                                        <span>ง. การดำเนินเหตุการณ์ (Progression)</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout ml-4>
                                    <v-flex>
                                        <v-radio-group v-model="form.progression" row>
                                            <v-radio color="#3E7662" label="1. แก้ไขแล้ว (Resolved)" value="1"></v-radio>
                                            <v-radio color="#3E7662" label="2. ยังคงมีปัญหา (Ongoing)" value="2"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>

                                <!-- row 5 -->
                                <v-layout mt-8 mb-3>
                                    <v-flex style="text-align: left;font-weight: bold;">
                                        <span>จ. การเปลี่ยนแปลงโครงร่างการวิจัย</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout ml-4>
                                    <v-flex>
                                        <v-radio-group v-model="form.hasChangeResearch">
                                            <v-radio color="#3E7662" label="1. ไม่เปลี่ยน" value="1"></v-radio>
                                            <v-radio color="#3E7662" label="2. เปลี่ยน (ส่งรายงานส่วนแก้ไขเพิ่มเติมโครงร่าง การวิจัย RF 02_2560 ให้คณะอนุกรรมการฯ)" value="2"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>

                                <!-- row 6 -->
                                <v-layout mt-8 mb-3>
                                    <v-flex style="text-align: left;font-weight: bold;">
                                        <span>ฉ. การเปลี่ยนแปลงเอกสารชี้แจงข้อมูลอาสาสมัคร</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout ml-4>
                                    <v-flex>
                                        <v-radio-group v-model="form.hasChangeDocument">
                                            <v-radio color="#3E7662" label="1. ไม่เปลี่ยน" value="1"></v-radio>
                                            <v-radio color="#3E7662" label="2. เปลี่ยน (ส่งรายงานส่วนแก้ไขเพิ่มเติมโครงร่าง การวิจัย RF 02_2560 ให้คณะอนุกรรมการฯ)" value="2"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>

                                <v-layout pt-10>
                                    <v-flex xs11 style="text-align: left;font-size: 14px; color: #CC3D45">
                                        <span>
                                            *ถ้าเป็นเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรง (ก 1-5) ผู้วิจัยควรส่งรายงานแก่คณะอนุกรรมการพิจารณาโครงการวิจัย พบ. ภายใน 7 วัน หลังทราบเหตุการณ์
                                        </span>
                                    </v-flex>
                                </v-layout>

                                <v-layout pt-12 justify-space-between style="font-weight:bold;margin-left: -30px;margin-right: -30px">
                                    <v-flex d-flex justify-start>
                                        <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                                    </v-flex>
                                    <v-flex d-flex justify-end>
                                        <span>หน้า 1 จาก 1 หน้า</span>
                                    </v-flex>
                                </v-layout>

                            </v-flex>
                        </v-layout>


                        <!-- Button Save -->
                        <v-layout mt-6>
                            <v-flex mb-12 style="text-align: right;">
                                <v-layout>
                                    <v-flex>
                                        <v-btn style="color: #3E7662" class="mx-4" depressed  color="#ffffff" @click="viewData">ย้อนกลับ</v-btn>
                                        <v-btn depressed  dark color="#3E7662" @click="save">
                                            <v-icon class="mr-3">add</v-icon>
                                            <span>บันทึกข้อมูล</span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <loading
                        color="#527281"
                        :active.sync="isLoading"
                        :can-cancel="false"
                        :is-full-page="fullPage"
                ></loading>
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    import TextfieldForm from "../../components/input/TextfieldForm";
    import DateInputForm from "../../components/input/DateInputForm";
    import TextareaForm from "../../components/input/TextareaForm";
    import Swal from 'sweetalert2';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapState } from "vuex";

    export default {
        name: "FormRF06",
        components: {
            TextfieldForm,
            DateInputForm,
            TextareaForm,
            Loading,
        },
        data: () => ({
            isLoading: false,
            fullPage: true,
            form: {
                researchCode: '',
                researchName:'',
                firstName:'',
                lastName:'',
                affiliationAndPhoneNumber:'',
                volunteer_checkbox: false,
                volunteerDepartment:'',
                volunteerCode:'',
                birthDate:'',
                age:'',
                gender:'',
                date:'',
                detail:'',
                type:'',
                relation:'',
                signatureFirstName:'',
                signatureLastName:'',
                reportDate:'',
                severity:'1',
                hasCure:'',
                hasRecurrentAfterStop:'',
                progression:'',
                hasChangeResearch:'',
                hasChangeDocument:'',
            },
            birthDate: '',
            date: '',
            reportDate: '',
            researchAllHeaders: [
                {text: 'Version', value: 'version', align: "center"},
                { text: 'หน้า / บรรทัด', value: 'page', align: "center" },
                { text: 'ข้อมูลเดิม / ข้อเสนอแนะ', value: 'data', align: "center" },
            ],
            // itemResearchAll: [
            //     {
            //         version: '01',
            //         page: 'การสำรวจข้อมูลพื้นฐานประชากรและความชุกของปัจจัยเสี่ยงทางด้านสุขภาพ',
            //         data: 'เสร็จสิ้น',
            //     },
            //     {
            //         version: '02',
            //         page: 'การศึกษาความชุกและปัจจัยเสี่ยงของโรคติดเชื้อปรสิตในลำไส้ในเด็กนักเรียน',
            //         data: 'รอดำเนินการ',
            //     },
            // ],
            userID: '',
        }),
        computed: {
            ...mapState({
                user: state => state.Auth.user
            })
        },
        created() {
            // Check Permission Access
            //if (this.user.currentRole !== 3) {
             //   this.$router.go(-1);
           // }

            this.userID = this.$route.query.userID;
            this.getRF04_2();
        },
        methods:{
            updateData(name, val) {
                this.form[name] = val;
            },
            updateDate(name,val) {
                if (name === "birthDate") {
                    this.form.birthDate = val.date;
                    this.birthDate = this.changeDate(val.date);
                }
                if (name === "date") {
                    this.form.date = val.date;
                    this.date = this.changeDate(val.date);
                }
                if (name === "reportDate") {
                    this.form.reportDate = val.date;
                    this.reportDate = this.changeDate(val.date);
                }
            },
            changeDate(val) {
                //change date start
                let sub_year = val.substring(0,4);
                let sub_month = val.substring(5,7);
                let sub_day = val.substring(8,10);
                sub_year = parseInt(sub_year)+543;
                let changeDate = sub_day + '/' + sub_month + '/' + sub_year;
                return changeDate;
            },
            viewData() {
                this.$router.push({name: 'ViewDataPostApprove', query: { id: this.userID }})
            },
            getRF04_2() {
                this.isLoading = true;
                this.$store.dispatch("FormRF/getRF04_2", this.$route.query.rfID).then(res => {
                    this.form.researchCode = res.researchCode;
                    this.form.researchName = res.researchName;
                    this.form.firstName = res.firstName;
                    this.form.lastName = res.lastName;
                    this.form.affiliationAndPhoneNumber = res.affiliationAndPhoneNumber;
                    this.form.volunteer_checkbox = res.volunteer_checkbox;
                    this.form.volunteerDepartment = res.volunteerDepartment;
                    this.form.volunteerCode = res.volunteerCode;
                    this.form.birthDate = res.birthDate;
                    this.birthDate = this.changeDate(res.birthDate);
                    this.form.age = res.age;
                    this.form.gender = res.gender;
                    this.form.date = res.date;
                    this.date = this.changeDate(res.date);
                    this.form.detail = res.detail;
                    this.form.type = res.type;
                    this.form.relation = res.relation;
                    this.form.signatureFirstName = res.signatureFirstName;
                    this.form.signatureLastName = res.signatureLastName;
                    this.form.reportDate = res.reportDate;
                    this.reportDate = this.changeDate(res.reportDate);
                    this.form.severity = res.severity;
                    this.form.hasCure = res.hasCure;
                    this.form.hasRecurrentAfterStop = res.hasRecurrentAfterStop;
                    this.form.progression = res.progression;
                    this.form.hasChangeResearch = res.hasChangeResearch;
                    this.form.hasChangeDocument = res.hasChangeDocument;
                    this.isLoading = false;
                }).catch(e => {
                    this.isLoading = false;
                })
            },
            save() {
                Swal.fire({
                    title: 'คุณต้องการบันทึกหรือไม่?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3E7662',
                    cancelButtonColor: 'rgb(189, 189, 189)',
                    confirmButtonText: 'ใช่ บันทึก',
                }).then((result) => {
                    if (result.value) {
                        this.isLoading = true;
                        this.form['researchID'] = this.$route.query.id;
                        this.$store.dispatch("FormRF/saveRF04_2", this.form).then(res => {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'บันทึกสำเร็จ',
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.isLoading = false;
                            this.viewData();
                        }).catch(e => {
                            this.isLoading = false;
                            if (e.response.data.errors) {
                                for (var k in e.response.data.errors) {
                                Swal.fire({
                                    title: "เกิดข้อผิดพลาด",
                                    text: e.response.data.errors[k][0],
                                    icon: "warning",
                                    confirmButtonColor: "#3E7662",
                                }).then(() => {
                                    this.$vuetify.goTo(`#${k}`);
                                });
                                }
                            }
                            // Swal.fire({
                            //     title: 'Save failed!',
                            //     text: 'บันทึกไม่สำเร็จ',
                            //     icon: 'warning',
                            // });
                            // this.isLoading = false;
                        })
                    }
                });
            },
            volunteerChangeCheckbox() {
                if (!this.form.volunteer_checkbox) {
                    this.form.volunteerDepartment = '';
                }
            },
            setData() {
                this.form.researchCode =  '01';
                this.form.researchName = 'Test Research';
                this.form.firstName = 'แดง';
                this.form.lastName = 'ใจร้าย';
                this.form.affiliationAndPhoneNumber = '05555555';
                this.form.volunteer_checkbox =  true;
                this.form.volunteerDepartment = 'Test';
                this.form.volunteerCode = 'Test';
                this.form.birthDate = new Date().toISOString().substr(0, 10);
                this.form.age = '25';
                this.form.gender = '1';
                this.form.date = new Date().toISOString().substr(0, 10);
                this.form.detail = 'รายละเอียดเหตุการณ์ไม่พึงประสงค์ (รวมทั้งการตรวจทางห้องปฏิบัติการ)';
                this.form.type = '1';
                this.form.relation = '1';
                this.form.signatureFirstName = 'จาป';
                this.form.signatureLastName = 'ชาวสวน';
                this.form.reportDate = new Date().toISOString().substr(0, 10);
                this.form.severity = '1';
                this.form.hasCure = '1';
                this.form.hasRecurrentAfterStop = '1';
                this.form.progression = '1';
                this.form.hasChangeResearch = '1';
                this.form.hasChangeDocument = '1';
            }
        },
    }
</script>

<style lang="scss">
    label.v-label.theme--light {
        color: #544A44;
    }
</style>
